import React from 'react';
import { Button } from '@components/amc/Button';
import ChatPopupWrapper from '../ChatPopupWrapper';
import { DateTime } from 'luxon';
import * as S from '@styles/chat/scheduleMessage.style';
import { IconCircleXFilled, IconX } from '@tabler/icons-react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ScheduledMessageListPopup = ({
  popupRef,
  messagesList,
  defaultPosition,
  isTablet,
  onSelectMessage,
  onClosePopup,
  handleDrag,
  onDeleteMessage,
  onClickResetMessageFormButton
}) => {
  return /*#__PURE__*/_jsx(ChatPopupWrapper, {
    draggableCoreProps: {
      onDrag: handleDrag
    },
    popupRef: popupRef,
    defaultPosition: defaultPosition,
    rndProps: {
      enableResizing: {
        bottom: !isTablet
      }
    },
    children: /*#__PURE__*/_jsxs("section", {
      className: "flex flex-col h-full",
      children: [/*#__PURE__*/_jsxs(S.ScheduledMessagePopupHeader, {
        className: "drag-handle",
        children: [/*#__PURE__*/_jsx("div", {
          className: "middle title",
          children: "\uC608\uC57D \uBAA9\uB85D"
        }), /*#__PURE__*/_jsx(Button, {
          variant: "Ghost",
          icon: /*#__PURE__*/_jsx(IconX, {}),
          size: "Medium",
          onClick: () => onClosePopup()
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "flex-grow overflow-y-auto",
        children: /*#__PURE__*/_jsx("div", {
          className: "flex flex-col gap-2 h-fit bg-my-gray-95",
          children: messagesList.length > 0 ? messagesList.map(message => /*#__PURE__*/_jsxs(S.ScheduledMessageListItem, {
            onClick: () => onSelectMessage(message),
            children: [/*#__PURE__*/_jsxs("div", {
              className: "recipient",
              children: [/*#__PURE__*/_jsxs("div", {
                children: ["To. ", message.studentName]
              }), /*#__PURE__*/_jsx("button", {
                onClick: async e => {
                  e.stopPropagation();
                  onDeleteMessage(message);
                },
                children: /*#__PURE__*/_jsx(IconCircleXFilled, {
                  size: 16,
                  color: "var(--gray-10)"
                })
              })]
            }), /*#__PURE__*/_jsx("div", {
              className: "time",
              children: DateTime.fromISO(message.scheduledAt).toFormat('yyyy. M. d EEEE a h:mm', {
                locale: 'ko'
              })
            }), /*#__PURE__*/_jsx("div", {
              className: "content",
              children: message.message
            })]
          }, message.id)) : /*#__PURE__*/_jsx("div", {
            className: "w-full p-3 text-center bg-my-gray-100 text-body-md-500 text-my-gray-10",
            children: "\uC608\uC57D\uB41C \uBA54\uC2DC\uC9C0\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4."
          })
        })
      }), /*#__PURE__*/_jsxs(S.ScheduledMessagePopupFooter, {
        children: [/*#__PURE__*/_jsx("div", {}), /*#__PURE__*/_jsx(Button, {
          variant: "Outline",
          size: "Medium",
          text: "\uC0C8\uB85C \uC608\uC57D",
          onClick: onClickResetMessageFormButton
        })]
      })]
    })
  });
};
export default ScheduledMessageListPopup;